import styles from './styles/loader.css'
import defaultSplash from '../img/splash.png'

const splash =
  typeof window.TKL_SPLASH !== 'undefined' ? window.TKL_SPLASH : defaultSplash

const Loader = ({ message }) => (
  <div className={styles.loader}>
    <div className={styles.logo} style={{ backgroundImage: `url(${splash})` }}></div>
    <div className={styles.message}>{message}</div>
  </div>
)

export default Loader
